import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLayoutNone = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 107,
	height: 107,
	viewBox: "0 0 107 107",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 1.6272,
			y: 1.95557,
			width: 104,
			height: 104,
			rx: 1,
			stroke: "#BFD2DB",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 15.77,
			y: 29.9795,
			width: 75.7143,
			height: 5.04762,
			rx: 2,
			fill: "#BFD2DB"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 15.77,
			y: 45.1221,
			width: 75.7143,
			height: 5.04762,
			rx: 2,
			fill: "#BFD2DB"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 15.77,
			y: 65.3125,
			width: 37.8571,
			height: 10.0952,
			rx: 2,
			fill: "#BFD2DB"
		})
	]
});
export default SvgLayoutNone;
